import jQuery from 'jquery';

/**
 * Adds data-lang attribute to Mobi2Go root view.
 * This allows custom css based on the language.
 * Wait for the app to be ready so that the
 * external modal container has been created.
 */
Mobi2Go.onReady(function() {
    jQuery('.m2g-view').attr('data-lang', Mobi2Go.app.language);
});

moment.locale(Mobi2Go.app.language);
/**
 * Loading the numeral locale but overriding the currency symbol with the headoffice currency.
 * i.e Person browsing NZ store in french language.
 * French are used to the comma decimal delimiter and the currency sign after the number.
 * Would it make sense to keep those to give the best experience to the customer? Probably.
 */
if (Mobi2Go.app.language in numeral.locales) {
    numeral.locale(Mobi2Go.app.language);
    numeral.locales[Mobi2Go.app.language].currency.symbol =
        Mobi2Go.headoffice.currency_symbol;
}
